import React from "react";
import { useSelector } from "react-redux";
import { getKey, getTab } from "../../../../shared/utils/tabsUtils";
import { usePermission } from "../../../../shared/hooks/usePermission";
import { canShowScheduleMiniWidget } from "../../../../shared/utils/userDetailsUtils";
import CalendarMobileWidget from "../../../../shared/components/pages/calenderPage/calendarMobileWidget/CalendarMobileWidget";
import MyLearningWidget from "../../myLearningPage/myLearningWidget/MyLearningWidget";
import CreateStudyGroupMiniWidget from "../../../features/createStudyGroupMiniWidget/CreateStudyGroupMiniWidget";
import UsefulToolsCarouselWidget from "../../../../shared/components/widgetCarousel/usefulToolsCarouselWidget/UsefulToolsCarouselWidget";
import DiscoveryCarouselWidget from "../../../../shared/components/widgetCarousel/discoveryCarouselWidget/DiscoveryCarouselWidget";
import ProfessionalDevelopmentCarouselWidget from "../../../../shared/components/widgetCarousel/professionalDevelopmentCarouselWidget/ProfessionalDevelopmentCarouselWidget";
import FocusCarousel from "../../../../shared/components/ui/focusCarousel/FocusCarousel";
import ShortcutCarouselWidget from "../../../../shared/components/widgetCarousel/shortcutCarouselWidget/ShortcutCarouselWidget";
import GoogleMeetCarouselWidget from "../../../../shared/components/widgetCarousel/googleMeetCarouselWidget/GoogleMeetCarouselWidget";
import AssignCarouselWidget from "../../../../shared/components/widgetCarousel/assignCarouselWidget/AssignCarouselWidget";
import ScheduleCarouselWidget from "../../../../shared/components/widgetCarousel/scheduleCarouselWidget/ScheduleCarouselWidget";
import MessagesCarouselWidget from "../../../../shared/components/widgetCarousel/messagesCarouselWidget/MessagesCarouselWidget";
import HeaderMobile from "../../../layout/layoutMobile/headerMobile/HeaderMobile";
import BgtCarouselWidget from "../../../../shared/components/widgetCarousel/bgtCarouselWidget/BgtCarouselWidget";
import RealisticIsraelCarouselWidget from "../../../../shared/components/widgetCarousel/realisticIsraelCarouselWidget/RealisticIsraelCarouselWidget";
import ChampionshipCarouselWidget from "../../../../shared/components/widgetCarousel/championshipCarouselWidget/ChampionshipCarouselWidget";
import ManagementCarouselWidget from "../../../../shared/components/widgetCarousel/managementCarouselWidget/ManagementCarouselWidget";
import DefaultLogoWidget from "../../../../shared/components/widget/defaultLogoWidget/DefaultLogoWidget";
import SchoolImageWidget from "../../../../shared/components/widget/schoolImageWidget/SchoolImageWidget";
import BotsCarouselWidget from "../../../../shared/components/widgetCarousel/botsCarouselWidget/BotsCarouselWidget";
import FinancialEducationCarouselWidget from "../../../../shared/components/widgetCarousel/financialEducationCarouselWidget/FinancialEducationCarouselWidget";
import PencilCaseWidget from "../../../../shared/components/widgetCarousel/pencilCaseWidget/PencilCaseWidget";
import classes from "./HomeMobile.module.css";

const HomeMobile = () => {

    const { userDetails, user } = useSelector(state => state.auth);
    const hasPermission = usePermission();
    const canSeeGoogleMeet = hasPermission(getTab("googleMeet")?.visibleTo);
    const canSeeBgt = hasPermission(getKey("bgt"));
    const canSeeRealistic = hasPermission(getTab("realisticIsrael")?.visibleTo);
    const canSeeChampionship = hasPermission(getTab("championship")?.visibleTo);
    const canSeeManagement = hasPermission(getTab("managerDashboard")?.visibleTo);
    const canSeeBots = hasPermission(getTab("bots")?.visibleTo);
    const canSeeFinancialEducation = hasPermission(getTab("financialEducation")?.visibleTo);

    return (
        <div className={`${classes.HomeMobile} HomeMobile`}>
            <HeaderMobile />
            <CalendarMobileWidget />
            {userDetails?.defaultSchool?.imageUrl ? <SchoolImageWidget /> : <DefaultLogoWidget />}
            <MyLearningWidget />
            <CreateStudyGroupMiniWidget className={classes.CreateStudyGroupMiniWidget} />
            <FocusCarousel itemSize={100} activeScale={1.6} showDots={false} className={classes.WidgetsCarousel}>
                {canSeeBgt && <BgtCarouselWidget />}
                {canSeeRealistic && <RealisticIsraelCarouselWidget />}
                {canSeeGoogleMeet && <GoogleMeetCarouselWidget />}
                <AssignCarouselWidget />
                <DiscoveryCarouselWidget />
                <PencilCaseWidget />
                {canShowScheduleMiniWidget(userDetails) && <ScheduleCarouselWidget />}
                <MessagesCarouselWidget />
                <UsefulToolsCarouselWidget />
                {canSeeBots && <BotsCarouselWidget />}
                {canSeeFinancialEducation && <FinancialEducationCarouselWidget />}
                <ProfessionalDevelopmentCarouselWidget />
                <ShortcutCarouselWidget key={userDetails?.defaultSchool?.id} />
                {canSeeChampionship && <ChampionshipCarouselWidget />}
                {canSeeManagement && <ManagementCarouselWidget />}
            </FocusCarousel>
        </div>
    );
};

export default HomeMobile;
